import { render, staticRenderFns } from "./UpdateProductCategoryDialog.vue?vue&type=template&id=10e76da5"
import script from "./UpdateProductCategoryDialog.vue?vue&type=script&lang=js"
export * from "./UpdateProductCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateProductCategoryDialog.vue?vue&type=style&index=0&id=10e76da5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports